import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getMyAppoinments,
  canclePatientAppoinments,
} from "../../../api/apiHandler";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment-timezone";
import Select from "react-select";

function MyAppointments() {
  const navigate = useNavigate();
  const [myAppointmentList, setMyAppointmentList] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [userTimezone, setUserTimezone] = useState("");
  const [updatePage, setUpdatePage] = useState(false);
  const userRole = localStorage.getItem("user_login_type_role");
  const doctorSpecialities = [
    { value: 0, label: "All" },
    //{ value: 1, label: "PENDING" },
    { value: 2, label: "ACCEPTED" },
    { value: 3, label: "REJECTED" },
    { value: 4, label: "ONGOING" },
    { value: 5, label: "DONE" },
    { value: 6, label: "CANCELLED" },
  ];

  const [selectedStatus, setSelectedStatus] = useState(doctorSpecialities[0]);

  useEffect(() => {
    const timezone = moment.tz.guess();
    setUserTimezone(timezone);
    getMyAppoinments({
      page: pageNo,
      record_count: perPage,
      search_text: searchQuery,
      appointmentStatus: selectedStatus.value,
    }).then((response) => {
      // Swal.close();
      response = JSON.parse(response);
      console.log(response, "response");
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setMyAppointmentList(response.data.doctor_data);
        setTotalRecordCount(
          Math.ceil(response.data.total_record_count / perPage)
        );
      } else {
        setMyAppointmentList([]);
        setTotalRecordCount(0);
      }
      setUpdatePage(false);
    });

    // Swal.close();
  }, [searchQuery, pageNo, selectedStatus, updatePage]);

  console.log(myAppointmentList, "myAppointmentList");

  const cancleAppointment = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to cancel this appointment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Exit",
    }).then((result) => {
      if (result.isConfirmed) {
        canclePatientAppoinments({ appointment_id: id }).then((response) => {
          response = JSON.parse(response);

          if (response.code == process.env.REACT_APP_SUCCESS) {
            setUpdatePage(true);
            setPageNo(1);
            setSearchQuery("");
            Swal.fire(
              "Cancelled!",
              "Your appointment has been cancelled.",
              "success"
            );
          } else {
            Swal.fire("Error!", response.message, "error");
          }
        });
      }
    });
  };

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  return (
    <>
      <Header />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">My Appointments </p>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={userRole == "4" ? "/priest/home" : "/doctor/home"}
                    className="font_14"
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  My Appointments{" "}
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div className="row">
                <div className="col-md-6 my-1">
                  <ul
                    className="nav nav-pills mb-3 d-inline-flex rounded p-2 commonTabs"
                    style={{ background: "#e3e3e3" }}
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <Link
                        to={
                          userRole == "4"
                            ? "/priest/patient-appointment"
                            : "/doctor/patient-appointment"
                        }
                        className="nav-link "
                        // id="pills-home-tab"
                        // data-bs-toggle="pill"
                        // data-bs-target="#pills-home"
                        // type="button"
                        // role="tab"
                        // aria-controls="pills-home"
                        // aria-selected="true"
                      >
                        Appointments
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to={
                          userRole == "4"
                            ? "/priest/my-appointment"
                            : "/doctor/my-appointment"
                        }
                        className="nav-link active"
                        // id="pills-profile-tab"
                        // data-bs-toggle="pill"
                        // data-bs-target="#pills-profile"
                        // type="button"
                        // role="tab"
                        // aria-controls="pills-profile"
                        // aria-selected="false"
                      >
                        My Appointments
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-3 my-1">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Filter by Status:
                  </label>
                  <div className="d-flex align-items-center gap-10 w-100">
                    <div className="w-100" style={{ maxWidth: 200 }}>
                      <Select
                        placeholder="Filter by Status"
                        className="react-select__menu"
                        classNamePrefix="select"
                        name="selectedStatus"
                        options={doctorSpecialities}
                        value={selectedStatus}
                        onChange={(selectedOption) => {
                          setSelectedStatus(selectedOption);
                          setPageNo(1);
                          setSearchQuery("");
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="search-bar col-lg-3 col-md-3 my-1">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Search by:
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Name or Email"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <table
                  id="mangeUser"
                  className="table table-hover dataTable js-exportable"
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Patient Name</th>
                      <th>Phone Number</th>
                      <th>Email Address</th>
                      <th>Date Time</th>
                      <th>Request Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {myAppointmentList &&
                      myAppointmentList.map((item, index) => {
                        return (
                          <tr id={item.id} key={index}>
                            <td>{item.id}</td>

                            <td>
                              <h3 className="doc-details">
                                <div className="doc-profile">
                                  <img
                                    src={item.patient_information.profile_image}
                                    alt=""
                                  />
                                </div>
                                {item.patient_information.doctor_full_name}
                              </h3>
                            </td>
                            <td>
                              {item.patient_information.country_code +
                                " " +
                                item.patient_information.doctor_phone_no}
                            </td>
                            <td>{item.patient_information.doctor_email}</td>
                            <td>
                              {/* {item.appointment_date+" "+item.appointment_time} */}
                              {/* {moment.utc(item.appointment_date + " " + item.appointment_time).tz(userTimezone).format('DD/MM/YYYY hh:mm A')} */}
                              {moment
                                .tz(
                                  `${item.appointment_date} ${item.appointment_time}`,
                                  "YYYY-MM-DD hh:mm A",
                                  "UTC"
                                )
                                .tz(userTimezone)
                                .format("DD/MM/YYYY hh:mm A")}
                            </td>
                            <td>
                              {/* <p className="meeting-status status-ongoing font_600 ">{item.appointment_status}</p> */}
                              <button>
                                {item.appointment_status === 1 ? (
                                  <p className="meeting-status status-pending font_600 ">
                                    PENDING
                                  </p>
                                ) : item.appointment_status === 2 ? (
                                  <p className="meeting-status status-accept font_600 ">
                                    ACCEPTED
                                  </p>
                                ) : item.appointment_status === 3 ? (
                                  <p className="meeting-status status-reject font_600 ">
                                    REJECTED
                                  </p>
                                ) : item.appointment_status === 4 ? (
                                  <p className="meeting-status status-ongoing font_600 ">
                                    ONGOING
                                  </p>
                                ) : item.appointment_status === 5 ? (
                                  <p className="meeting-status status-accept font_600 ">
                                    DONE
                                  </p>
                                ) : (
                                  <p className="meeting-status status-reject font_600 ">
                                    CANCELLED
                                  </p>
                                )}
                              </button>
                            </td>
                            {item.appointment_status === 1 ||
                            item.appointment_status === 2 ? (
                              <td>
                                <button
                                  className="meeting-status btn-danger font_600 btn "
                                  disabled={
                                    !(
                                      item.appointment_status === 1 ||
                                      item.appointment_status === 2
                                    )
                                  }
                                  onClick={() => cancleAppointment(item.id)}
                                >
                                  Cancel
                                </button>
                              </td>
                            ) : (
                              <td>N/A</td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=" > "
                  onPageChange={handlePageClick}
                  pageCount={totalRecordCount}
                  previousLabel=" < "
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                  activeLinkClassName="active-link"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default MyAppointments;
